const UserRoutes = {
    path: '/user',
    component: () => import('@/layouts/full/FullLayoutUser.vue'),
    redirect: '/user/menu', // redirect to first child
    meta: { requiresAuth: true },
    children: [
        // Dashboard
        {
            path: 'menu',
            name: 'Dashboard',
            component: () => import('@/views/User/MenuView.vue'),
        },
        // Attendance
        {
            path: 'online-attendance',
            name: 'OnlineAttendanceView',
            component: () => import('@/views/TimeAttendance/OnlineAttendance/OnlineAttendanceView.vue'),
        },
        {
            path: 'qr-attendance',
            name: 'Check In Out',
            component: () => import('@/views/QR/EmployeeAttendanceQR.vue'),
        },
        {
            path: 'time-attendance',
            name: 'Attendances',
            component: () => import('@/views/User/UserTimeAttendance.vue'),
        },
        {
            path: 'my-attendance',
            name: 'My Attendances',
            component: () => import('@/views/User/MyAttendance.vue'),
        },
        {
            path: 'team-attendance',
            name: 'Team Attendance',
            component: () => import('@/views/User/TeamAttendanceView.vue'),
        },
        // Notifications
        {
            path: 'notification',
            name: 'Notification',
            component: () => import('@/views/User/NotificationView.vue'),
        },
        // Password
        {
            path: 'change-password',
            name: 'Change Password',
            component: () => import('@/views/User/ChangePasswordView.vue'),
        },
        // Profile
        {
            path: 'profile',
            name: 'My Profile',
            component: () => import('@/views/User/MyProfileView.vue'),
        },
        {
            path: 'profile/:id',
            name: 'User Profile',
            component: () => import('@/views/User/UserProfileView.vue'),
            props: true,
        },
        // Leave
        {
            path: 'requests',
            name: 'My Requests',
            component: () => import('@/views/User/UserRequest.vue'),
        },
        {
            path: 'mission-request',
            name: 'Mission Request',
            component: () => import('@/views/User/MissionRequestInput.vue'),
        },
        {
            path: '/user/Leave/request-form',
            name: 'Leave Request Form',
            component: () => import('@/views/Leave/LeaveRequestFormView.vue'),
        },
        {
            path: '/user/leave/menu',
            name: 'Request Menu',
            component: () => import('@/views/Leave/LeaveMenuView.vue'),
        },
        {
            path: '/user/leave/history',
            name: 'Leave History',
            component: () => import('@/views/Leave/LeaveHistoryView.vue'),
        },
        {
            path: '/user/leave/requester',
            name: 'Leave Requester',
            component: () => import('@/views/Leave/LeaveRequestView.vue'),
        },
        {
            path: '/user/leave/history-flow/:id',
            name: 'Leave History Flow',
            component: () => import('@/views/Leave/LeaveHistoryFlowView.vue'),
            props: true,
        },
        // Overtime
        {
            path: 'overtime/menu',
            name: 'Over Time Menu',
            component: () => import('@/views/Overtime/OvertimeMenuView.vue'),
        },
        {
            path: 'overtime/approval',
            name: 'Over Time Approval',
            component: () => import('@/views/Overtime/OvertimeApprovalView.vue'),
        },
        {
            path: 'overtime/my',
            name: 'My Over Time',
            component: () => import('@/views/Overtime/MyOvertimeView.vue'),
        },
        // Performance
        {
            path: 'performance/menu',
            name: 'Performance Menu',
            component: () => import('@/views/Performance/PerformanceMenuView.vue'),
        },
        {
            path: 'performance/monthly-evaluation',
            name: 'Monthly Evaluation',
            component: () => import('@/views/Performance/User/Monthly/MonthlyEvaluationView.vue'),
        },
        {
            path: 'performance/monthly-form/:id',
            name: 'Monthly Form',
            component: () => import('@/views/Performance/User/Monthly/MonthlyEvaluationFormView.vue'),
            props: true,
        },
        {
            path: 'performance/semesterly-evaluation',
            name: 'Semesterly Evaluation',
            component: () => import('@/views/Performance/SemesterlyEvaluationView.vue'),
        },
        {
            path: 'performance/yearly-evaluation',
            name: 'Yearly Evaluation',
            component: () => import('@/views/Performance/YearlyEvaluationView.vue'),
        },
        {
            path: 'performance/leader-probationary-evaluation',
            name: 'Leader Evaluation for Probationary Team Members',
            component: () => import('@/views/Performance/LeaderEvaluationForProbationaryTeamMembers.vue'),
        },
        {
            path: 'performance/leader-evaluation/:id',
            name: 'Leader Evaluation for Team Members',
            component: () => import('@/views/Performance/LeaderEvaluationForProbationaryTeamMembers.vue'),
        },
        {
            path: 'probationary-list',
            name: 'Probationary List',
            component: () => import('@/views/Performance/User/Probationary/ProbationaryList.vue'),
        },
        {
            path: 'probationary-comment',
            name: 'Probationary Comment',
            component: () => import('@/views/Performance/User/Probationary/ProbationaryComment.vue'),
        },
        {
            path: 'performance/probationary-evaluation',
            name: 'Probationary Evaluation',
            component: () => import('@/views/Performance/User/Probationary/ProbationaryEvaluationView.vue'),
        },
        {
            path: 'performance/employee-evaluation',
            name: 'Employee Evaluation',
            component: () => import('@/views/Performance/EmployeeProbationaryEvaluation.vue'),
        },
        {
            path: 'performance/probationary-form/:id',
            name: 'Probationary Form',
            component: () => import('@/views/Performance/User/Probationary/ProbationaryEvaluationFormView.vue'),
            props: true,
        },
        {
            path: 'yearly-kpi-list',
            name: 'Yearly Evaluation',
            component: () => import('@/views/Performance/Admin/Yearly/YearlyEvaluationView.vue'),
        },
        {
            path: 'yearly-kpi-comment',
            name: 'Yearly Evaluated Comment',
            component: () => import('@/views/Performance/User/Yearly/ProbationaryComment.vue'),
        },
        // Bonus & Deduction
        {
            path: 'bonus-deduction',
            name: 'BonusDeduction',
            component: () => import('@/views/User/BonusDeductionView.vue'),
        },
        // Online Attendance Map
        {
            path: 'online-attendance/map/:id',
            name: 'OnlineAttendanceMap',
            component: () => import('@/views/TimeAttendance/OnlineAttendance/OnlineAttendanceMapView.vue'),
            props: true,
        },
        // Suggestions
        {
            path: 'comment-suggestion',
            name: 'UserSuggestion',
            component: () => import('@/views/Staffing/suggestion/UserSuggestionView.vue'),
        },
        {
            path: 'suggestion-history',
            name: 'UserSuggestionHistory',
            component: () => import('@/views/Staffing/suggestion/UserSuggestionHistoryView.vue'),
        },
        // Calendar
        {
            path: 'calendar',
            name: 'UserCalendar',
            component: () => import('@/views/User/UserCalendarView.vue'),
        },
        // Professional Competency
        {
            path: 'competency-assessment',
            name: 'CompetencyAssessment',
            component: () => import('@/views/User/CompetencyAssessment/CompetencyAssessmentView.vue'),
        },
        // Company Policy
        {
            path: 'policy',
            name: 'Company Policy',
            component: () => import('@/views/User/CompanyPolicyView.vue'),
        },

    ],
}

export default UserRoutes
